import ClothForm from "@/stock/pages/ClothForm";
import CutOfClothesForm from "@/stock/pages/CutOfClothesForm";
import StationeryForm from "@/stock/pages/StationeryForm";
import ExpendableMaterialForm from "@/stock/pages/ExpendableMaterialForm";
import PromotionalProductForm from "@/stock/pages/PromotionalProductForm";
import SewingAccessoryForm from "@/stock/pages/SewingAccessoryForm";
import PackageForm from "@/stock/pages/PackageForm";
import ProductForm from "@/stock/pages/ProductForm";
import StockEntityRecordsPage from "@/stock/pages/StockEntityRecordsPage";

const routes = [
  {
    path: "/products/:id",
    component: ProductForm,
  },
  {
    path: "/packages/:id",
    component: PackageForm,
  },
  {
    path: "/promotional_products/:id",
    component: PromotionalProductForm,
  },
  {
    path: "/sewing_accessories/:id",
    component: SewingAccessoryForm,
  },
  {
    path: "/expendable_materials/:id",
    component: ExpendableMaterialForm,
  },
  {
    path: "/stationery/:id",
    component: StationeryForm,
  },
  {
    path: "/cut_of_clothes/:id",
    component: CutOfClothesForm,
  },
  {
    path: "/cloths/:id",
    component: ClothForm,
  },
];

const stockEntities = [
  "cloths",
  "cut_of_clothes",
  "sewing_accessories",
  "stationery",
  "expendable_materials",
  "packages",
  "promotional_products",
  "products",
];
stockEntities.forEach((entity) => {
  routes.push({
    name: entity,
    path: `/${entity}`,
    component: StockEntityRecordsPage,
  });
});

export default routes;



// WEBPACK FOOTER //
// ./src/stock/routes.js